// extracted by mini-css-extract-plugin
module.exports = {"menuItems":"MenuItems_menuItems__2o-Zz","item":"MenuItems_item__3bxG9","top":"MenuItems_top__1Wvd5","bottom":"MenuItems_bottom__dgiLZ","mobile":"MenuItems_mobile__1Y_QT"};